export class ImportResultApiModel {
  public WasProcessed: boolean;
  public FailedCount: number;
  public ImportedCount: number;
  public Blob: Blob;
  public ShiftsAdded: number;
  public LocationsAdded: number;
  public ShiftsFailed: number;
  public LocationsFailed: number;
}
